module.exports = __webpack_public_path__ + "img/bo.6771901f.png";